<template lang="pug">
  div.loading
    img(src="../assets/images/loader.gif")
</template>
<script>
export default {
  name: 'loading'
}
</script>
<style lang = "scss" scoped>
.loading {
  text-align: center;
  margin: 1rem 0;
  img {
    width: 2.8125rem;
    height: 2.8125rem;
  }
}
</style>
